/**
 * Builds evaluation context for sticky banner rules from report payloads.
 * Pure helper — no side effects.
 */

export function buildStickyBannerContext(reportData, progressordata) {
  const marks = Number(reportData?.marks_obtained);
  const maxMarks = Number(reportData?.maximum_marks);
  const scorePercent =
    Number.isFinite(marks) && Number.isFinite(maxMarks) && maxMarks > 0
      ? (marks / maxMarks) * 100
      : null;

  const subjectSections =
    progressordata && typeof progressordata === "object"
      ? Object.entries(progressordata).map(([name, section]) => ({
          sectionName: name,
          marksObtained: Number(section?.marks_obtained),
          totalMarks: Number(section?.total_marks)
        }))
      : [];

  return {
    scorePercent,
    subjectSections,
    reportData: reportData ?? null,
    progressordata: progressordata ?? null
  };
}
